import { PropertyResponseDto } from "@/common/api/datasources/Api";

interface ServiceRequestsTabProps {
    property: PropertyResponseDto;
}

export const ServiceRequestsTab = ({ property }: ServiceRequestsTabProps) => {
    return (
        <div className="space-y-4">
            <div className="bg-white rounded-lg shadow p-6">
                <h2 className="text-xl font-semibold mb-4">Заяви на сервісне обслуговування</h2>
                <p className="text-muted-foreground">Тут буде відображатись інформація про заяви на сервісне обслуговування для цієї нерухомості.</p>
            </div>
        </div>
    );
}; 